import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/CardMembership';
import create from './create';
import edit from './edit';
import list from './list';

const certifications: ResourceProps = {
  name: 'certifications',
  icon,
  options: { label: 'Certificações' },
  create,
  edit,
  list
};

export default certifications;
